module.exports = __webpack_public_path__ + "img/paysucc.d49bbe41.png";